// extracted by mini-css-extract-plugin
export default {"newRequestSection":"AccountRequests_newRequestSection__K6JE4","sectionHeading":"AccountRequests_sectionHeading__RfAWA"};